import { render, staticRenderFns } from "./pubCnyGoodExpt.vue?vue&type=template&id=6f13b946&scoped=true&"
import script from "./pubCnyGoodExpt.vue?vue&type=script&lang=js&"
export * from "./pubCnyGoodExpt.vue?vue&type=script&lang=js&"
import style0 from "./pubCnyGoodExpt.vue?vue&type=style&index=0&id=6f13b946&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13b946",
  null
  
)

export default component.exports